import { render } from "./StatsPlatform.vue?vue&type=template&id=4e82591a"
import script from "./StatsPlatform.vue?vue&type=script&lang=js"
export * from "./StatsPlatform.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__